import { StepType } from '../../../main/types/asset/asset.enums.ts';
import { TaskType } from '../../../main/types/asset/asset.enums.ts';
import { Lesson, LessonStep, LessonTask, LessonTaskStepKey } from '../../../main/types/asset/lesson.types.ts';

export const LESSON_SLICE_NAME = 'lesson';

export interface LessonSliceState {
  isLoading: boolean;
  isGodMode: boolean;
  currentLesson?: Lesson;
  currentTask?: LessonTask;
  currentStep?: LessonStep;
  currentLessonTaskStepKey?: LessonTaskStepKey;
  taskStepViewCount: Partial<Record<TaskType, Partial<Record<StepType, number>>>>;
}
